module.exports = __webpack_public_path__ + "img/Comic04-2.3bd230c7.png";